import React from "react";

// Small, consistent "Xaluca Originals" label rendered on every experience
// card (featured grid, secondary carousel) and on the detail page hero.
//
// Variant controls colour so the badge reads against both light cards and
// dark editorial hero gradients.

const XalucaOriginalsBadge = ({ variant = "light", className = "", testid = "xaluca-originals-badge" }) => {
  const palette =
    variant === "dark"
      ? "border-[#D4A373]/60 text-[#D4A373] bg-[#1A1513]/40 backdrop-blur-sm"
      : "border-[#C16542]/50 text-[#C16542] bg-[#FDFBF7]/85";
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[10px] tracking-[0.3em] uppercase px-3 py-1 border rounded-full font-medium ${palette} ${className}`}
      data-testid={testid}
    >
      <span
        className={`inline-block w-1 h-1 rounded-full ${variant === "dark" ? "bg-[#D4A373]" : "bg-[#C16542]"}`}
        aria-hidden="true"
      />
      Xaluca Originals
    </span>
  );
};

export default XalucaOriginalsBadge;
